__turbopack_context__.v({
  "button": "ScrollToTop-module__8MgTlq__button",
  "buttonVisible": "ScrollToTop-module__8MgTlq__buttonVisible",
});
